import { Injectable } from '@angular/core';

export const PPF_CONSTRAINTS = {
  yearlyInvestment: { min: 500, max: 150_000, step: 500 },
  rate:             { min: 1,   max: 12,      step: 0.1 },
  tenureYears:      { min: 15,  max: 50,      step: 1 }
} as const;

export interface PpfYearRow {
  year: number;
  openingBalance: number;
  deposit: number;
  interest: number;
  closingBalance: number;
}

export interface PpfResult {
  rows: PpfYearRow[];
  totalInvested: number;
  totalInterest: number;
  maturityValue: number;
}

@Injectable({ providedIn: 'root' })
export class PpfCalculatorService {

  calculate(yearlyInvestment: number, annualRate: number, tenureYears: number): PpfResult {
    const rate = annualRate / 100;
    const rows: PpfYearRow[] = [];
    let balance = 0;

    for (let year = 1; year <= tenureYears; year++) {
      const opening = balance;
      const interest = (opening + yearlyInvestment) * rate;
      const closing = opening + yearlyInvestment + interest;
      rows.push({ year, openingBalance: opening, deposit: yearlyInvestment, interest, closingBalance: closing });
      balance = closing;
    }

    const totalInvested = yearlyInvestment * tenureYears;
    return {
      rows,
      totalInvested,
      totalInterest: balance - totalInvested,
      maturityValue: balance
    };
  }
}
